import { useEffect } from 'react';

import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../store/hooks';
import { PlatformModel } from '../../../../../../shared/models/platform.model';
import { getApkPlatforms } from '../../../thunks/get-apk-platforms.thunk';

export const useGetApkPlatforms = (platformIds: number[]): PlatformModel[] => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!platformIds.length) {
      dispatch(getApkPlatforms());
    }
  }, []);

  return useAppSelector(state => state.appsFeature.releases.platforms);
};
